import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <div style={styles.badge}>INSTITUTIONAL R&D &bull; MSME REGISTERED</div>
                <h1 style={styles.title}>About Arivu Nest Research and Development</h1>
                <p style={styles.subtitle}>A Unit / Initiative of Jjegan Graphers &bull; In Collaboration with Kani Rathnam Equality Foundation</p>
            </header>

            <div style={styles.content}>
                
                {/* 1. Official Identity */}
                <section style={styles.section}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '14px', flexWrap: 'wrap' }}>
                        <img src="/images/logos/arivu-nest-logo.png" alt="Arivu Nest" style={{ height: '48px', width: 'auto' }} />
                        <img src="/images/logos/msme-logo.png" alt="MSME Govt of India" style={{ height: '42px', width: 'auto' }} />
                        <img src="/images/logos/jjegan-logo.png" alt="Jjegan Graphers" style={{ height: '42px', width: 'auto' }} />
                        <img src="/images/logos/kani-rathnam-logo.png" alt="Kani Rathnam Foundation" style={{ height: '42px', width: 'auto' }} />
                    </div>
                    <h2 style={styles.heading}>🏛️ Our Institutional Identity & Roots</h2>
                    <p style={styles.text}>
                        <strong>Arivu Nest – Research and Development</strong> is an accredited academic, research, and skill incubation organization established in Tamil Nadu (Kovilpatti & Virudhunagar). 
                        We operate as an official unit and initiative of <strong>Jjegan Graphers</strong>, formally registered under the <strong>Ministry of Micro, Small & Medium Enterprises (MSME), Government of India</strong> (Udyam Reg. No: <code>UDYAM-TN-32-0048110</code>).
                    </p>
                    <p style={styles.text}>
                        Working in close partnership with <strong>Kani Rathnam Equality Foundation</strong>, Arivu Nest was established to bridge academic learning, frontier AI technologies, and high-impact research with grassroots student empowerment.
                    </p>
                </section>

                {/* 2. Leadership & Academic Excellence */}
                <section style={styles.section}>
                    <h2 style={styles.heading}>👩‍🏫 Leadership & Academic Excellence</h2>
                    <div style={styles.leadershipCard}>
                        <h3 style={styles.leaderName}>Dr. S. Sabitha Shunmuga Priya</h3>
                        <p style={styles.leaderRole}>
                            <strong>Chairman</strong>, Arivu Nest Research and Development<br />
                            <strong>Founder & Proprietrix</strong>, Jjegan Graphers<br />
                            <strong>Assistant Professor in English</strong>, KGISL Institute of Technology
                        </p>
                        <p style={styles.text}>
                            With over <strong>11 years of university-level teaching experience</strong> and <strong>5 years of specialized communication research</strong>, Dr. Sabitha bridges rigorous academic pedagogy with practical student confidence. Her scholarly accomplishments include:
                        </p>
                        <ul style={styles.list}>
                            <li>🏆 <strong>State Recognitions:</strong> Honored with the "Best Researcher" and "Best Teacher" awards from PIMES, Pondicherry.</li>
                            <li>📚 <strong>Prolific Research:</strong> Authored 28 ISBN-numbered articles, published 16 peer-reviewed papers in ISSN-indexed international journals, and edited 3 academic books.</li>
                            <li>🌏 <strong>Global Collaborations:</strong> Conducted international research initiatives with scholars and authors from Indonesia and Singapore.</li>
                            <li>🏅 <strong>Record Breaking:</strong> Served on the organizing committee for the prestigious "Assist World Record Program" four times.</li>
                            <li>🎓 <strong>Faculty Development:</strong> Organized multiple National-Level Faculty Development Programs (FDPs) and student capacity-building workshops.</li>
                        </ul>
                    </div>
                </section>

                {/* 3. Co-Founders & Patrons */}
                <section style={styles.section}>
                    <h2 style={styles.heading}>🤝 Patrons & Founding Pillars</h2>
                    <p style={styles.text}>
                        Arivu Nest R&D draws its foundational strength from the industrial guidance of <strong>Jjegan Graphers</strong> (Virudhunagar):
                    </p>
                    <div style={styles.patronsGrid}>
                        <div style={styles.patronCard}>
                            <img src="/images/logos/jjegan-logo.png" alt="Jjegan Graphers" style={{ height: '36px', marginBottom: '8px' }} />
                            <h4 style={styles.patronName}>Mr. S. Kothala Radhakrishnan</h4>
                            <p style={styles.patronTitle}>Co-Founder, Jjegan Graphers, Virudhunagar</p>
                        </div>
                        <div style={styles.patronCard}>
                            <img src="/images/logos/jjegan-logo.png" alt="Jjegan Graphers" style={{ height: '36px', marginBottom: '8px' }} />
                            <h4 style={styles.patronName}>Mr. K. Jeganathan</h4>
                            <p style={styles.patronTitle}>Chairman / Proprietor, Jjegan Graphers, Virudhunagar</p>
                        </div>
                    </div>
                </section>

                                {/* 4. Executive Directorate & Core Administration */}
                <section style={styles.section}>
                    <h2 style={styles.heading}>⚖️ Executive Directorate & Administration</h2>
                    <p style={styles.text}>
                        The operational governance, strategic planning, technical architecture, and fiscal management of Arivu Nest Research and Development are directed by the Executive Directorate:
                    </p>
                    <div style={styles.execGrid}>
                        <div style={styles.execCard}>
                            <div style={styles.execBadge}>EXECUTIVE LEADERSHIP</div>
                            <h3 style={styles.execName}>Nandhakumar Murugan</h3>
                            <div style={styles.execRole}>Chief Operations Officer (COO) / Head of Technology &amp; Strategy</div>
                            <p style={styles.execDesc}>
                                Directs institutional operations, strategic planning, verified accreditation workflows, digital initiatives, and academic partnerships.
                            </p>
                        </div>
                        <div style={styles.execCard}>
                            <div style={styles.execBadge}>EXECUTIVE LEADERSHIP</div>
                            <h3 style={styles.execName}>Mohamed Irfan</h3>
                            <div style={styles.execRole}>Chief Technology Officer (CTO) / Head of Operations &amp; Administration</div>
                            <p style={styles.execDesc}>
                                Oversees technological infrastructure, systems engineering, platform development, and organizational administration.
                            </p>
                        </div>
                        <div style={styles.execCard}>
                            <div style={{ ...styles.execBadge, background: '#fef3c7', color: '#b45309', border: '1px solid #fde68a' }}>FINANCE &amp; TREASURY</div>
                            <h3 style={styles.execName}>Mrs. Jothy</h3>
                            <div style={{ ...styles.execRole, color: '#b45309' }}>Treasurer / Head of Finance Management</div>
                            <p style={styles.execDesc}>
                                Responsible for institutional fiscal governance, treasury oversight, budget management, and financial compliance under Jjegan Graphers.
                            </p>
                        </div>
                    </div>
                </section>

                {/* 5. Core Pillars Beyond Learning */}
                <section style={styles.section}>
                    <h2 style={styles.heading}>🔬 The 4 Operational Wings of Arivu Nest</h2>
                    <div style={styles.wingsGrid}>
                        <div style={styles.wingCard}>
                            <div style={styles.wingIcon}>📊</div>
                            <h4 style={styles.wingTitle}>1. Academic Research & Publications</h4>
                            <p style={styles.wingDesc}>
                                Publication of ISBN-indexed volumes, international conference proceedings, and linguistic studies advancing communication psychology.
                            </p>
                        </div>

                        <div style={styles.wingCard}>
                            <div style={styles.wingIcon}>💼</div>
                            <h4 style={styles.wingTitle}>2. Student Internships & Incubation</h4>
                            <p style={styles.wingDesc}>
                                Hands-on technical and academic internships for college students (B.Tech, Arts, Science) featuring verifiable commendation certificates.
                            </p>
                        </div>

                        <div style={styles.wingCard}>
                            <div style={styles.wingIcon}>🗣️</div>
                            <h4 style={styles.wingTitle}>3. AI Communication Labs</h4>
                            <p style={styles.wingDesc}>
                                Next-gen interactive web portal (arivunest.com) featuring Google Gemini AI speech feedback, Grammar Kata, and confidence-first modules.
                            </p>
                        </div>

                        <div style={styles.wingCard}>
                            <div style={styles.wingIcon}>🕊️</div>
                            <h4 style={styles.wingTitle}>4. Social Impact & Equal Opportunity</h4>
                            <p style={styles.wingDesc}>
                                Grassroots educational outreach, student workshops, and equal learning access in partnership with Kani Rathnam Equality Foundation.
                            </p>
                        </div>
                    </div>
                </section>

                <div style={styles.ctaBox}>
                    <h3 style={{ margin: '0 0 10px', fontSize: '20px', color: '#0f172a' }}>Explore Our Initiatives</h3>
                    <p style={{ margin: '0 0 20px', color: '#64748b', fontSize: '14px' }}>
                        Connect with our team for academic research collaborations, student internships, or institutional training programs.
                    </p>
                    <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Link to="/courses" style={styles.primaryBtn}>Explore Courses & AI Labs</Link>
                        <Link to="/contact" style={styles.secondaryBtn}>Contact Our Centers</Link>
                    </div>
                </div>

            </div>
        </div>
    );
};

const styles = {
    container: { maxWidth: '1000px', margin: '0 auto', padding: 'clamp(40px, 6vw, 80px) 20px', fontFamily: "'Inter', sans-serif" },
    header: { textAlign: 'center', marginBottom: '50px' },
    badge: { display: 'inline-block', background: '#ecfdf5', color: '#047857', border: '1px solid #a7f3d0', padding: '5px 14px', borderRadius: '999px', fontSize: '11px', fontWeight: '800', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '14px' },
    title: { fontSize: 'clamp(26px, 5vw, 38px)', color: '#0f172a', fontWeight: '800', margin: '0 0 10px 0', letterSpacing: '-0.5px' },
    subtitle: { fontSize: '16px', color: '#059669', fontWeight: '600', maxWidth: '700px', margin: '0 auto' },
    content: { maxWidth: '850px', margin: '0 auto' },
    section: { marginBottom: '45px' },
    heading: { fontSize: '22px', color: '#0f172a', fontWeight: '700', marginBottom: '16px', borderBottom: '2px solid #f1f5f9', paddingBottom: '8px' },
    text: { lineHeight: '1.75', color: '#334155', fontSize: '15px', marginBottom: '16px' },
    leadershipCard: { background: '#f8fafc', border: '1.5px solid #e2e8f0', borderRadius: '12px', padding: '24px', margin: '16px 0' },
    leaderName: { margin: '0 0 6px 0', fontSize: '20px', fontWeight: '800', color: '#0f172a' },
    leaderRole: { margin: '0 0 16px 0', fontSize: '13.5px', color: '#059669', lineHeight: '1.6' },
    list: { paddingLeft: '20px', lineHeight: '1.8', color: '#334155', fontSize: '14px' },
    patronsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '16px', marginTop: '14px' },
    patronCard: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '16px 20px' },
    patronName: { margin: '0 0 4px 0', fontSize: '16px', fontWeight: '700', color: '#0f172a' },
    patronTitle: { margin: 0, fontSize: '13px', color: '#64748b' },
    execGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '18px', marginTop: '16px' },
    execCard: { background: '#ffffff', border: '1.5px solid #e2e8f0', borderRadius: '12px', padding: '22px', boxShadow: '0 2px 8px rgba(0,0,0,0.03)', display: 'flex', flexDirection: 'column' },
    execBadge: { display: 'inline-block', alignSelf: 'flex-start', background: '#ecfdf5', color: '#047857', border: '1px solid #a7f3d0', padding: '3px 10px', borderRadius: '6px', fontSize: '10.5px', fontWeight: '800', letterSpacing: '0.8px', marginBottom: '10px' },
    execName: { margin: '0 0 4px 0', fontSize: '17px', fontWeight: '800', color: '#0f172a' },
    execRole: { margin: '0 0 10px 0', fontSize: '13px', color: '#059669', fontWeight: '700', lineHeight: '1.4' },
    execDesc: { margin: 0, fontSize: '13px', color: '#64748b', lineHeight: '1.6' },
    wingsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '18px', marginTop: '16px' },
    wingCard: { background: '#ffffff', border: '1.5px solid #e2e8f0', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.03)' },
    wingIcon: { fontSize: '26px', marginBottom: '10px' },
    wingTitle: { margin: '0 0 8px 0', fontSize: '15px', fontWeight: '700', color: '#0f172a' },
    wingDesc: { margin: 0, fontSize: '13px', color: '#64748b', lineHeight: '1.5' },
    ctaBox: { background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)', border: '1.5px solid #a7f3d0', borderRadius: '14px', padding: '32px', textAlign: 'center', marginTop: '40px' },
    primaryBtn: { background: '#059669', color: '#ffffff', textDecoration: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: '700', fontSize: '14px' },
    secondaryBtn: { background: '#ffffff', color: '#059669', border: '1px solid #059669', textDecoration: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: '700', fontSize: '14px' }
};

export default AboutUs;
